<app-auth-form
	[isRegister]="2"
	[loading]="loading"
	(formSubmit)="onReset($event)"
></app-auth-form>
